import React, { createContext, useContext } from 'react';
interface ReviewModeValue {
  showReviewNotes: boolean;
}
const ReviewModeContext = createContext<ReviewModeValue>({
  showReviewNotes: false
});
export function ReviewModeProvider({
  showReviewNotes,
  children
}: {
  showReviewNotes: boolean;
  children: React.ReactNode;
}) {
  return <ReviewModeContext.Provider value={{
    showReviewNotes
  }} data-id="element-590" data-mp="2d7gpbigf1c61">{children}</ReviewModeContext.Provider>;
}
export function useReviewMode() {
  return useContext(ReviewModeContext);
}